import React from 'react';
import PropTypes from 'prop-types';

import {connectAppEnv} from '../../../app/app-env';
import {OEVersion} from '../../../react-oe/oe-version';
import {OETarget} from '../../../react-oe/oe-target';
import OEIconCodes from '../../../lib/oe-icon-codes';
import {OECapBarPropTypes, OECapBarConfigFactory} from './oe-cap-bar-model';
import OEStdCapBarController from './std/oe-std-cap-bar-controller';
import OEAmbossCapBar from '../../custom/amboss/oe-amboss-cap-bar';
import OEAnatomyCapBar from '../../custom/anatomy/oe-anatomy-cap-bar';
import OEBayerCapBar from '../../custom/bayer/oe-bayer-cap-bar';
import OEBBrauncastCapBar from '../../custom/bbraun/oe-bbraun-cap-bar';
import OECellCapBar from '../../custom/cell/oe-cell-cap-bar';
import OEDemoCapBar from '../../custom/demo/oe-demo-cap-bar';
import OEEarCapBar from '../../custom/ear/oe-ear-cap-bar';
import OEEquineHoofCapBar from '../../custom/equineHoof/oe-equine-hoof-cap-bar';
import OEImplantcastCapBar from '../../custom/implantcast/oe-implantcast-cap-bar';
import OEOrthoCapBar from '../../custom/ortho/oe-ortho-cap-bar';
import OESchoolCapBar from '../../custom/school/oe-school-cap-bar';
import OEScienceCapBar from '../../custom/science/oe-science-cap-bar';
import OESkinCapBar from '../../custom/skin/oe-skin-cap-bar';
import OESportCapBar from '../../custom/sport/oe-sport-cap-bar';
import OESurgeryCapBar from '../../custom/surgery/oe-surgery-cap-bar';
import OEThiemeCapBar from '../../custom/thieme/oe-thieme-cap-bar';
import OEToxnetzCapBar from '../../custom/toxnetz/oe-toxnetz-cap-bar';
import OEXRayCapBar from '../../custom/xRay/oe-xray-cap-bar';
import OEXRayIcarusCapBar from '../../custom/xRayIcarus/oe-xray-icarus-cap-bar';

export function OECapBarFactory(props)  {
    if(props.opaque || !props.config.available)    return null;

    if(props.version === OEVersion.amboss) {
        return <OEAmbossCapBar {...props}/>
    } else if(props.version === OEVersion.anatomy) {
        return <OEAnatomyCapBar {...props}/>
    } else if(props.version === OEVersion.bayer || props.version === OEVersion.eyeOCT || props.version === OEVersion.knowOn)  {
        return <OEBayerCapBar {...props}/>
    } else if(props.version === OEVersion.bbraun)  {
        return <OEBBrauncastCapBar {...props}/>
    } else if(props.version === OEVersion.cambridgeCell || props.version === OEVersion.cell) {
        return <OECellCapBar {...props}/>
    } else if(props.version === OEVersion.demo) {
        return <OEDemoCapBar {...props}/>
    } else if(props.version === OEVersion.ear) {
        return <OEEarCapBar {...props}/>
    } else if(props.version === OEVersion.equineHoof)   {
        return <OEEquineHoofCapBar {...props}/>
    } else if(props.version === OEVersion.implantcast)  {
        return <OEImplantcastCapBar {...props}/>
    } else if(props.version === OEVersion.ortho)   {
        return <OEOrthoCapBar {...props}/>
    } else if(props.version === OEVersion.school)   {
        return <OESchoolCapBar {...props}/>
    } else if(props.version === OEVersion.science)   {
        return <OEScienceCapBar {...props}/>
    } else if(props.version === OEVersion.skin || props.version === OEVersion.ionto)   {
        return <OESkinCapBar {...props}/>
    } else if(props.version === OEVersion.sport)   {
        return <OESportCapBar {...props}/>
    } else if(props.version === OEVersion.surgery)   {
        return <OESurgeryCapBar {...props}/>
    } else if(props.version === OEVersion.thieme)   {
        return <OEThiemeCapBar {...props}/>
    } else if(props.version === OEVersion.toxnetz)  {
        return <OEToxnetzCapBar {...props}/>
    } else if(props.version === OEVersion.xRay || props.version === OEVersion.xRayMin) {
        return <OEXRayCapBar {...props}/>
    } else if(props.version === OEVersion.xRayIcarus)    {
        return <OEXRayIcarusCapBar {...props}/>
    } else if(props.version === OEVersion.zeissOpti)    {
        return (
            <OEStdCapBarController
                {...props}
                targetTypes={[
                    {id: OETarget.humanEye2, target: OETarget.humanEye2, icon: OEIconCodes.zeissOpti.anatomyTarget, titleId: 'target_menu_anatomy'},
                    {id: OETarget.zeissOpti2, target: OETarget.zeissOpti2, icon: OEIconCodes.zeissOpti.optiTarget, titleId: 'target_menu_zeissOpti2', targetMenuHidden: true},
                    {id: OETarget.zeissUV, target: OETarget.zeissUV, icon: OEIconCodes.zeissOpti.UVTarget, titleId: 'target_menu_zeissUV', targetMenuHidden: true}
                ]}
                targetTypeForTarget={(target) => { return [OETarget.zeissOpti2, OETarget.zeissUV].includes(target) ? target : OETarget.humanEye2; }}
                targetTypeTargetForTarget={(targetType, target) => targetType.target}
            />
        );
    }

    return null;
}

OECapBarFactory.defaultProps = {
    moduleId:       '',
    config:         OECapBarConfigFactory.buildStdConfig()
};

OECapBarFactory.propTypes = {
    moduleId:       PropTypes.string,
    version:        PropTypes.string,
    target:         PropTypes.string,
    config:         OECapBarPropTypes.config
};

export default connectAppEnv((env) => {
    return {
        version:    env.config.version,
        target:     env.config.target,
        config:     env.config.module.uiLayerConfig.capBar
    };
})(OECapBarFactory);